import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from "@/components/icon/Icon";
import { ArrowRight, Sizes } from "@/components/icon/IconList";
import Link from "next/link";
import React, { useRef } from "react";
import { useTheme } from "styled-components";
import { useResizeObserver } from "usehooks-ts";
import { WarnBoxLayout } from "../../styles/ProductDetail.style";
const WarnBox = (param)=>{
    let { productType  } = param;
    const theme = useTheme();
    const ref = useRef(null);
    const { width =0  } = useResizeObserver({
        ref,
        box: "border-box"
    });
    const DefaultWarnBox = (param)=>{
        let { children  } = param;
        return /*#__PURE__*/ _jsx(WarnBoxLayout, {
            ref: ref,
            children: /*#__PURE__*/ _jsxs("div", {
                className: "license",
                children: [
                    /*#__PURE__*/ _jsx("h5", {
                        children: "구매 시 확인해주세요!"
                    }),
                    children
                ]
            })
        });
    };
    switch(productType){
        case "aladinbook":
            return /*#__PURE__*/ _jsx(DefaultWarnBox, {
                children: /*#__PURE__*/ _jsxs("p", {
                    children: [
                        /*#__PURE__*/ _jsx("b", {
                            children: "실물 교재 혹은 도서를 배송 받는 상품입니다."
                        }),
                        "\xa0상품 수령까지 영업일 기준 2~4일 정도 소요됩니다."
                    ]
                })
            });
        case "ebookUniversity":
        case "ebook":
            return /*#__PURE__*/ _jsx(DefaultWarnBox, {
                children: /*#__PURE__*/ _jsxs("p", {
                    children: [
                        /*#__PURE__*/ _jsx("b", {
                            children: "굿노트6 앱 (iOS)에서만 열리는 eBook 상품입니다."
                        }),
                        "\xa0아이폰, 아이패드, 맥북 내 굿노트 6 앱이 설치되어 있어야하며 굿노트 계정(무료계정 가능)이 필요합니다."
                    ]
                })
            });
        case "workbook":
        case "textbook":
            return /*#__PURE__*/ _jsxs(DefaultWarnBox, {
                children: [
                    /*#__PURE__*/ _jsxs("p", {
                        children: [
                            /*#__PURE__*/ _jsx("b", {
                                children: "해당 상품은 수업자료가 아닙니다."
                            }),
                            "저작 및 판매 등의 이용 권리를 1년 단위로 계약하는 라이선스 상품입니다."
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Link, {
                        className: width > 400 ? "link-default" : null,
                        href: "https://solvookguide.oopy.io/qna/8",
                        target: "_blank",
                        children: [
                            "자세히 보기",
                            " ",
                            /*#__PURE__*/ _jsx(Icon, {
                                icon: ArrowRight,
                                size: Sizes.xsmall,
                                color: theme.new.colors.sol_gray_600
                            })
                        ]
                    })
                ]
            });
        default:
            return null;
    }
};
export default WarnBox;
